import React, { useEffect, useState } from 'react';
import type { FC } from 'react';
import axios from 'axios';
import { OrganizationAdmin } from 'src/types/organizationAdmin';

interface LogoProps {
    [key: string]: any;
    height?: number;
    width?: number;
}

const Logo: FC<LogoProps> = (props, height?, width?) => {

    const organizationAdmin: OrganizationAdmin = JSON.parse(localStorage.getItem('user'));
    const [organizationLogo, setOrganizationLogo] = useState<string>();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!organizationLogo && organizationAdmin && organizationAdmin.organization_id) {
            let params = {
                organization_id: organizationAdmin.organization_id,
            };
            axios.post(process.env.REACT_APP_SERVER_URL + '/organization/1.0/get/logo', params)
                .then(function (response) {
                    if (response && response.data) {
                        setOrganizationLogo(response.data)
                    }
                    else {
                        setOrganizationLogo('/static/logo.png')
                    }
                })
                .catch(function (error) {
                    setOrganizationLogo('/static/logo.png')
                })
            setLoading(false)
        }
        else {
            setLoading(false);
        }

    }, []);

    if (loading) {
        return null;
    }
    else {
        return (
            <img
                style={{ cursor: 'pointer', height: '2rem' }}
                height={height}
                width={width}
                alt="Logo"
                src={organizationLogo}
                {...props}
            />
        );
    }
}

export default Logo;
